module.exports = __webpack_public_path__ + "img/categorie-coquillages-famille-boutrais-big.d16af7fe.jpg";